<template>
  <MotionSynthesis/>
</template>

<script>
import MotionSynthesis from './components/MotionSynthesis_random_synthesis.vue'
// import MotionSynthesis from './components/MotionSynthesis_bvh.vue'

export default {
  name: 'App',
  components: {
    MotionSynthesis
  }
}
</script>

<style>
#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
